<script setup lang="ts">
const article = inject(keys.currentArticle)

const episodes = computed(() =>
  article?.contentType === 'podcast'
    ? article.episodes
    : article?.podcastEpisodes,
)
</script>

<template>
  <main id="main-content">
    <UiArticlesCoverWithImage v-if="article?.cover?.url" />
    <UiArticlesCoverWithoutImage v-else class="mb-8" />
    <UArticleContainer>
      <UiArticlesShareLinks />
      <UiArticlesBody class="mt-8 mb-16 min-h-4" />
      <ul v-if="episodes?.length" class="mt-4 mb-16 flex min-h-80 w-full flex-col gap-8 pb-16">
        <li
          v-for="episode in episodes"
          :key="episode.id"
          class="flex flex-col gap-2"
        >
          <ClientOnly>
            <div v-html="episode.embed" />
          </ClientOnly>
          <UAccordion
            v-if="episode.transcription"
            :items="[{ content: episode.transcription, label: 'Transkribering' }]"
            :ui="{
              item: 'bg-white rounded-md',
              content: 'pb-4',
            }"
          >
            <template #content="{ item }">
              <div v-html="item.content" />
            </template>
          </UAccordion>
        </li>
      </ul>
      <template v-if="article?.contentType === 'article' && article.podcast">
        <h2 class="text-green-50">
          Podkast-episode
        </h2>
        <div class="mt-4 mb-8" v-html="article.podcast" />
      </template>
      <slot />
    </UArticleContainer>
  </main>
</template>
